<template src="./Appointments.html"></template>

<script>

import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },

  created() {
    this.$store.dispatch("doctors/getAppointments", this.itemId).then((res) => {
      this.doctor = res
      this.daysOfWeek.forEach(element => {
        this.doctor.appointments.forEach((e) => {
          if (element.value == e.day) {
            element.from = e.startTime;
            element.to = e.endTime;
            element.enabled = e.enabled;
          }
        })
      });
    });


  },
  computed: {
    rooms() {
      return [
        { value: 1, label: " الغرفة 1 " },
        { value: 2, label: "الغرفة 2" },

      ]
    },
    doctors() {
      return [
        { value: 1, label: "د. أحمد على " },
        { value: 2, label: "د. الهادي المختار" },

      ]
    },

  },
  data() {
    return {
      doctor: {
        appointments: []
      },
      vm: {
        doctorId: null,
      },
      daysOfWeek:
        [{ value: 6, label: "السبت", from: null, to: null, enabled: false },
        { value: 0, label: "الاحد", from: null, to: null, enabled: false },
        { value: 1, label: "الاثنين", from: null, to: null, enabled: false },
        { value: 2, label: "الثلاثاء", from: null, to: null, enabled: false },
        { value: 3, label: "الاربعاء", from: null, to: null, enabled: false },
        { value: 4, label: "الخميس", from: null, to: null, enabled: false },
        { value: 5, label: "الجمعة", from: null, to: null, enabled: false },
        ],
      times:
        [{value: 7, label: "07:00 صباحا" },
        { value: 8, label: "08:00 صباحا" },
        { value: 9, label: "09:00 صباحا" },
        { value: 10, label: "10:00 صباحا" },
        { value: 11, label: "11:00 صباحا" },
        { value: 12, label: "12:00 مساءاَ" },
        { value: 13, label: "01:00 مساءاَ" },
        { value: 14, label: "02:00 مساءاَ" },
        { value: 15, label: "03:00 مساءاَ" },
        { value: 16, label: "04:00 مساءاَ" },
        { value: 17, label: "05:00 مساءاَ" },
        { value: 18, label: "06:00 مساءاَ" },
        { value: 19, label: "07:00 مساءاَ" },
        { value: 20, label: "08:00 مساءاَ" },
        { value: 21, label: "09:00 مساءاَ" },
        { value: 22, label: "10:00 مساءاَ" },
        { value: 23, label: "11:00 مساءاَ" },
        { value: 24, label: "12:00 مساءاَ" },
        { value: 1, label: "1:00 صباحا" },
        { value: 2, label: "2:00 صباحا" },
        { value: 3, label: "3:00 صباحا" },
        ],

    };
  },
  methods: {
    confirm() {
      let daysOfWeek = [];
      let isNotVaild = this.daysOfWeek.some((e) => e.enabled && (e.from == null || e.to == null))
      if (isNotVaild) {
        showAlert(`الرجاء التحقق من تعبئة اوقات ، كل الايام المحددة`);
        return false;
      }
      this.daysOfWeek.forEach((e) => {
        if (e.enabled && e.from != null && e.to != null) {
          daysOfWeek.push({
            day: e.value,
            startTime: e.from,
            endTime: e.to,
            enabled: e.enabled,
          });
        }
      })
      this.$store
        .dispatch("doctors/addAppointments", { id: this.itemId, payload: { appointments: daysOfWeek } })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    reset(index) {
      this.daysOfWeek[index].from = null;
      this.daysOfWeek[index].to = null;

    },
    timesTo(from) {
      console.log(from)
      return this.times
     // return this.times.filter((x) => x.value > from)
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 2);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>